import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarContribuinteDs, criarMunicipioDs } from "../../DataSources";
import Memoria from "../../Memoria";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  nome: "",
  apelido: "",
  mae: "",
  tipoDeDocumento: 0,
  documento: undefined,
  nomeDocumento: undefined,
  orgaoEmissor: undefined,
  nis: "",
  endereco: "",
  numero: "",
  complemento: "",
  cep: undefined,
  bairro: "",
  cidade: "",
  uf: "",
  pais: "Brasil",
  telefone: "",
  celular: "",
  email: "",
  obs: "",
  forneceMunicipio: 0,
  status: 0,
  origem: 0,
  onLine: false,
  _uiCpf: "",
  _uiCnpj: "",
  tipoPessoa: 2,
  loadIndicatorVisivel: false,
  textoBotao: "Salvar",
  documentosAlvara: "",
  municipioId: null
};

export default class ContribuinteForm extends React.Component {
  constructor(props) {
    super(props);

    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = { ...(_cadastroCorrente || template), _uiCarregando: true };
    this.contribuinteDs = criarContribuinteDs();
    this.municipiosDs = criarMunicipioDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    const tipoDocumento = [
      { id: 1, descricao: "PESSOA FÍSICA" },
      { id: 2, descricao: "PESSOA JURÍDICA" },
    ];

    const situacao = [
      { id: 0, descricao: "ATIVO" },
      { id: 1, descricao: "INATIVO" },
    ];

    const origem = [
      { id: 0, descricao: " " },
      { id: 1, descricao: "DO MUNICÍPIO" },
      { id: 2, descricao: "DE OUTRO MUNICÍPIO" },
    ];

    const forneceMunicipio = [
      { id: 0, descricao: " " },
      { id: 1, descricao: "SIM" },
      { id: 2, descricao: "NÃO" },
    ];

    this.opcoesOrigem = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: origem,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.forneceMunicipioOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: forneceMunicipio,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoPessoaOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tipoDocumento,
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) =>
        this.setState({ tipoDeDocumento: e.value === 1 ? 2 : 1 }),
    };

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      dataSource: situacao,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.renderLabel = this.renderLabel.bind(this);

    this.municipioOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: this.municipiosDs,
      valueExpr: "id",
      displayExpr: "nomeCompleto",
    };
  }

  renderLabel(data) {
    return <div>{this.state[data.dataField]}</div>;
  }

  async componentDidMount() {

    const results = await this.municipiosDs.load();

    this.municipioOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: results,
      valueExpr: "id",
      displayExpr: "nomeCompleto",
    };

    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.contribuinteDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data === undefined) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/contribuintes");
            }
            if (data.tipoPessoa === 0) {
              this.setState({
                ...data,
                _uiCpf: data.cpfCnpj,
                _uiCarregando: false,
                _uiMunicipioTxt: data.cidadeEUF
              });
            }
            console.log(data);
            if (data.tipoPessoa === 1) {
              this.setState({
                ...data,
                _uiCpf: data.cpfCnpj,
                _uiCarregando: false,
                _uiMunicipioTxt: data.cidadeEUF
              });
            }
            if (data.tipoPessoa === 2) {
              this.setState({
                ...data,
                _uiCnpj: data.cpfCnpj,
                _uiCarregando: false,
                _uiMunicipioTxt: data.cidadeEUF
              });
            }
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template, _uiCarregando: false });
      }
    } else {
      this.setState({ ..._cadastroCorrente, _uiCarregando: false });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="Contribuinte" colSpan={2} colCount={3}>
                <SimpleItem
                  dataField={"sequencial"}
                  colSpan={1}
                  render={this.renderLabel}
                >
                  <Label text="Inscrição" />
                </SimpleItem>
                <EmptyItem colSpan={1} />

                <SimpleItem
                  dataField={"status"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.situacaoOptions}
                >
                  <Label text="Situação" />
                </SimpleItem>
                <SimpleItem dataField={"nome"} colSpan={3}>
                  <Label text="Nome/Razão Social" />
                </SimpleItem>
                <SimpleItem dataField={"apelido"} colSpan={3}>
                  <Label text="Fantasia/Apelido" />
                </SimpleItem>
                <SimpleItem
                  dataField={"tipoPessoa"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoPessoaOpcoes}
                  colSpan={1}
                >
                  <Label text="Natureza" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"_uiCpf"}
                  colSpan={1}
                  editorOptions={{
                    mask: this.state.tipoPessoa === 1 ? "000.000.000-00" : "",
                    disabled: this.state.tipoPessoa !== 1,
                  }}
                >
                  <Label text="CPF" />
                </SimpleItem>
                <SimpleItem
                  dataField={"_uiCnpj"}
                  colSpan={1}
                  editorType={"dxTextBox"}
                  editorOptions={{
                    mask: this.state.tipoPessoa === 2 ? "AA.AAA.AAA/AAAA-00" : "",
                    maskChar: "_",
                    disabled: this.state.tipoPessoa !== 2,
                    maskInvalidMessage: "CNPJ inválido",
                    onValueChanged: (e) => {
                      // normaliza para maiúsculo — letra minúscula quebra o cálculo do DV
                      const upper = (e.value || "").toUpperCase();
                      if (upper !== e.value) e.component.option("value", upper);
                    },
                  }}
                >
                  <Label text="CNPJ" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"rg"}
                  colSpan={1}
                  editorOptions={{
                    disabled: this.state.tipoPessoa !== 1,
                  }}
                >
                  <Label text="RG" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dataNascimento"}
                  colSpan={1}
                  editorType="dxDateBox"
                  editorOptions={{
                    disabled: this.state.tipoPessoa !== 1,
                    width: "100%",
                    useMaskBehavior: true,
                  }}
                >
                  <Label text="Dt. Nascimento" />
                </SimpleItem>
                <SimpleItem
                  dataField={"nis"}
                  colSpan={2}
                  editorType="dxTextBox"
                  editorOptions={{
                    disabled: this.state.tipoPessoa !== 1,
                  }}
                >
                  <Label text="NIS/NIT" />
                </SimpleItem>
                <SimpleItem dataField={"crea"} colSpan={1}>
                  <Label text="CREA" />
                </SimpleItem>

                <SimpleItem dataField={"ie"} colSpan={1}>
                  <Label text="Insc. Estadual" />
                </SimpleItem>
                <SimpleItem dataField={"im"} colSpan={1}>
                  <Label text="Insc. Municipal" />
                </SimpleItem>
                <SimpleItem
                  dataField={"origem"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.opcoesOrigem}
                >
                  <Label text="Origem" />
                </SimpleItem>
                <SimpleItem
                  dataField={"forneceMunicipio"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.forneceMunicipioOpcoes}
                >
                  <Label text="Fornece Município" />
                </SimpleItem>

                <EmptyItem colSpan={3} />
              </GroupItem>
              <GroupItem caption="Dados de Endereço" colSpan={2} colCount={7}>
                <SimpleItem
                  dataField={"cep"}
                  editorOptions={{ mask: "00000-000" }}
                  colSpan={2}
                >
                  <Label text="CEP" />
                </SimpleItem>
                <EmptyItem colSpan={5} />
                <SimpleItem dataField={"endereco"} colSpan={6}>
                  <Label text="Logradouro" />
                </SimpleItem>
                <SimpleItem dataField={"numero"} colSpan={1}>
                  <Label text="Número" />
                </SimpleItem>
                <SimpleItem dataField={"complemento"} colSpan={2}>
                  <Label text="Complemento" />
                </SimpleItem>

                <SimpleItem dataField={"bairro"} colSpan={3}>
                  <Label text="Bairro" />
                </SimpleItem>

                <SimpleItem
                  dataField={"municipioId"}
                  colSpan={2}
                  editorType={"dxLookup"}
                  editorOptions={this.municipioOptions} helpText={this.state.municipioId != undefined && this.state.municipioId != null ? "" : "Selecione '" + this.state._uiMunicipioTxt + "' para corrigir cadastro"}>
                  <Label text={"Município"} />
                </SimpleItem>

              </GroupItem>
              <GroupItem caption={"Customização Alvarás"} colSpan={2} colCount={1}>
                <SimpleItem dataField={"documentosAlvara"} helpText={"Ex. para TLLF e TLAS: TLLF=RG 123456-6 SSP-CE; TLAS=SINES 123456-7"}>
                  <Label text="Documentos de Alvará" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="Contato" colSpan={2} colCount={4}>
                <SimpleItem
                  dataField={"telefone"}
                  editorType={"dxTextBox"}
                  editorOptions={{ mask: "(00) 0000-0000" }}
                >
                  <Label text="Telefone" />
                </SimpleItem>
                <SimpleItem
                  dataField={"celular"}
                  editorType={"dxTextBox"}
                  editorOptions={{ mask: "(00) 0 0000-0000" }}
                >
                  <Label text="Celular" />
                </SimpleItem>
                <SimpleItem dataField={"email"} colSpan={2}>
                  <Label text="E-mail" />
                </SimpleItem>
                <SimpleItem
                  dataField={"obs"}
                  editorType={"dxTextArea"}
                  colSpan={4}
                  editorOptions={{ height: 100 }}
                >
                  <Label text="Observações" />
                </SimpleItem>
                documentosAlvara
              </GroupItem>
            </Form>

            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                  disabled={this.state.loadIndicatorVisivel}
                >
                  <LoadIndicator
                    className="button-indicator"
                    id="small-indicator"
                    height={20}
                    width={20}
                    visible={this.state.loadIndicatorVisivel}
                    style={{ marginRight: "10px", verticalAlign: "middle" }}
                  />
                  <span className="dx-button-text">
                    {this.state.textoBotao}
                  </span>
                </Button>
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  disabled={this.state.loadIndicatorVisivel}
                  text="Cancelar"
                  width={120}
                  onClick={this.cancel}
                />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    this.setState(
      {
        loadIndicatorVisivel: true,
        textoBotao: "Salvando...",
      },
      async () => {
        const entidade = {
          ...this.state,
          cpfCnpj:
            this.state.tipoPessoa === 1
              ? this.state._uiCpf
              : this.state._uiCnpj,
        };

        await inserirOuAtualizar(this.contribuinteDs, entidade)
          .then(
            function () {
              notify("Contribuinte cadastrado com sucesso.", "success");
              _cadastroCorrente = undefined;
              _cancelando = true;
              Memoria.removerEdicao(this.props.location);
              this.props.history.goBack();
            }.bind(this)
          )
          .catch((error) => {
            try {
              var listaErros = JSON.parse(error.message);
              ShowError(listaErros);
            }
            catch (deserializeError) {
              notify(error, "Servidor retornou erro inesperado, favor contatar o suporte", 2000);
            }
            //ShowError(error.message);
            //notify(error, "error", 2000);
          });
        this.setState({ loadIndicatorVisivel: false, textoBotao: "Salvar" });
      }
    );
    // console.log("cadastro contribuinte", this.state);
    // await this.setState({
    //   loadIndicatorVisivel: true,
    // });
    // const entidade = {
    //   ...this.state,
    //   cpfCnpj:
    //     this.state.tipoPessoa == 1 ? this.state._uiCpf : this.state._uiCnpj,
    // };

    // inserirOuAtualizar(this.contribuinteDs, entidade)
    //   .then(
    //     function () {
    //       notify("Contribuinte cadastrado com sucesso.", "success");
    //       _cadastroCorrente = undefined;
    //       _cancelando = true;
    //       Memoria.removerEdicao(this.props.location);
    //       this.props.history.goBack();
    //     }.bind(this)
    //   )
    //   .catch(function (error) {
    //     console.log(error);
    //     this.setState({ loadIndicatorVisivel: false });
    //     notify(error, "error", 1500);
    //   });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
